import React, { useState } from 'react'
import TextField from '../../elements/form/TextField'
import TextareaField from '../../elements/form/TextareaField'
import { ERROR, UPDATING_DOWNLOADABLE } from '../../../store/types';
import { useDispatch, useSelector } from 'react-redux';
import { authHeader } from '../../../utils';
import { updateDownloadable } from '../../../store/actions/downloadablesActions';
import RadioGroup from '../../elements/form/RadioGroup';
import Checkbox from '../../elements/form/Checkbox';
import FileUpload from '../../elements/form/FileUpload';
import ModalActionButton from '../../elements/ModalActionButton';
import VideoIcon from '../../elements/icons/VideoIcon';
import AudioIcon from '../../elements/icons/AudioIcon';
import TextIcon from '../../elements/icons/TextIcon';
import ArrowPathIcon from '../../elements/icons/ArrowPathIcon';
import CloseIcon from '../../elements/icons/CloseIcon';
import { Switch } from '@headlessui/react';

const EditDownloadable = ({downloadable, closeFunction}) => {
    const dispatch = useDispatch()
    const downloadablesSelector = useSelector(state => state.downloadables)
    const [newDownloadablePayload, setNewDownloadablePayload] = useState(downloadable);
    const [validationErrors, setValidationErrors] = useState({});
    const validateForm = () => {
        let errors = {}
        if (!newDownloadablePayload.name || newDownloadablePayload.name === '') {
            errors.name = true
        }
        if (!newDownloadablePayload.description || newDownloadablePayload.description === '') {
            errors.description = true
        }

        if (!newDownloadablePayload.documentType || newDownloadablePayload.documentType === '') {
            errors.documentType = true
        }

        if(!downloadableAccess || downloadableAccess.length === 0) {
            errors.accessType = true
        }

        console.log('Form errors: ', errors)

  
        setValidationErrors(errors)
        return errors
    }

    const pushDownloadable = async () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            ...newDownloadablePayload, 
            ...{
                accessType: downloadableAccess
            }
        }

        if(file && file !== ''){
            const uploaded = await handleUpload(file) 
            payload.documentUrl = uploaded.data.file
        }

        dispatch(updateDownloadable(downloadable._id, payload))
    }

    const downloadableTypes = [
        {label: 'Image', value: 'IMAGE'},
        {label: 'Document', value: 'DOCUMENT'},
        {label: 'Audio', value: 'AUDIO'},
        {label: 'Video', value: 'VIDEO'},
    ]

    const [downloadableAccess, setDownloadableAccess] = useState(downloadable.accessType);
    const toggleAccess = (type) => {
        let temp = [...downloadableAccess]
        if (temp.includes(type)) {
            const indexOfType = downloadableAccess.findIndex(accessType => accessType === type)
            temp.splice(indexOfType, 1)
        } else {
            temp.push(type)
        }

        setDownloadableAccess(temp)
    }

    const [file, setFile] = useState(null);

    const handleUpload = async (file) => {
        console.log(file)
  
        var formData = new FormData()
        formData.append('file', file.file )
        const headers = new Headers();
        headers.append("Authorization",  authHeader().Authorization);

        try {
            dispatch({
                type: UPDATING_DOWNLOADABLE,
                payload: true
            })
            const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
                method: "POST",
                headers,
                body: formData,
            });
            const response = await doUpload.json();
    
           return response
        } catch (error) {
            dispatch({
                type: ERROR,
                error,
            });
        }
    }

    const allowedFormats = {
        'IMAGE': ['jpg', 'jpeg', 'png', 'gif'],
        'DOCUMENT': ['pdf', 'docx', 'doc', 'xls', 'xlsx'],
        'AUDIO': ['mp3', 'wav'],
        'VIDEO': ['mp4', 'mov', 'avi'],
    }

    const [documentTypeSelected, setDocumentTypeSelected] = useState(true);

    const [changingFile, setChangingFile] = useState(false);

    return (
        <div>
            <div className='flex items-start justify-between gap-x-[15px]'>
                <div className='w-full'>
                    <div className='w-full'>
                        <TextField
                            inputLabel="Downloadable name" 
                            fieldId="downloadable-name" 
                            inputType="text" 
                            preloadValue={newDownloadablePayload.name || ''}
                            hasError={validationErrors.name} 
                            returnFieldValue={(value)=>{setNewDownloadablePayload({...newDownloadablePayload, ...{name: value}})}}
                            requiredField={true}
                        />
                    </div>          

                    <div className='mt-4 w-full'>
                        <TextareaField
                            inputLabel="Description" 
                            fieldId="downloadable-description" 
                            inputType="text" 
                            requiredField={false}
                            preloadValue={newDownloadablePayload.description || ''}
                            hasError={validationErrors.description} 
                            returnFieldValue={(value)=>{setNewDownloadablePayload({...newDownloadablePayload, ...{description: value}})}}
                        />
                    </div>

                    <div className='mt-4'>
                        <RadioGroup 
                            items={downloadableTypes} 
                            inline={true}
                            preSelectedIndex={downloadableTypes.findIndex(item => item.value === newDownloadablePayload.documentType)}
                            inputLabel={'File Type'}
                            requiredField={true}
                            returnSelected={(value) => {
                                setDocumentTypeSelected(false)
                                setNewDownloadablePayload({...newDownloadablePayload, ...{documentType: value.value}})
                                setTimeout(() => {
                                    setDocumentTypeSelected(true)
                                }, 50);
                                }
                            } 
                            hasError={validationErrors && validationErrors.type}  
                            titleField='label'
                        />
                    </div>               

                </div>

                <div className='w-full'>

                    <div className="w-full flex justify-between gap-x-4 mb-4 border-secondary border-opacity-50">
                        <div className='w-10/12'>
                            <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Hidden Document</label>
                            <label className="text-xs text-gray-500 font-sofia-pro leading-[13px]">Hidden Downloadables will not be displayed on any platform for download, they will only be accessible via a secure link which can only be sent by admin.</label>
                        </div>
                        <div className='w-2/12 flex flex-row-reverse'>
                            <Switch
                                checked={newDownloadablePayload.hidden}
                                onChange={()=>{setNewDownloadablePayload({...newDownloadablePayload, ...{hidden: !newDownloadablePayload.hidden}})}}
                                className={`${
                                    newDownloadablePayload.hidden ? 'bg-accent' : 'bg-gray-400'
                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                >
                                <span className="sr-only">Requires fee</span>
                                <span
                                    className={`transform transition ease-in-out duration-200 ${
                                        newDownloadablePayload.hidden ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                    } inline-block w-3 h-3 transform rounded-full`}
                                />
                            </Switch>
                        </div>
                    </div>

                    {!newDownloadablePayload.hidden && <>
                        <label 
                            className={`text-sm lg:text-md cursor-text z-10 relative py-1 transition duration-200  
                            ${validationErrors && validationErrors.accessType ? 'text-red-600' : 'text-gray-500'}`}
                        >
                        <span className='text-red-600'>*</span> Access (Where will this file be displayed?)
                        </label> 

                        <div className='mt-4'>
                            <div className='w-full my-4'>
                                <Checkbox
                                    CheckboxLabel="Parents portal"
                                    checkboxToggleFunction={()=>{
                                        toggleAccess('PARENTS')
                                    }} 
                                    isChecked={downloadableAccess.includes('PARENTS')} 
                                    hasError={validationErrors && validationErrors.accessType} 
                                />
                            </div>
                        </div>                

                        <div className='mt-4'>
                            <div className='w-full my-4'>
                                <Checkbox
                                    CheckboxLabel="Students portal"
                                    checkboxToggleFunction={()=>{
                                        toggleAccess('STUDENTS')
                                    }} 
                                    isChecked={downloadableAccess.includes('STUDENTS')} 
                                    hasError={validationErrors && validationErrors.accessType} 
                                />
                            </div>
                        </div>                

                        <div className='mt-4'>
                            <div className='w-full my-4'>
                                <Checkbox
                                    CheckboxLabel="Visitors/Website Users"
                                    checkboxToggleFunction={()=>{
                                        toggleAccess('VISITORS')
                                    }} 
                                    isChecked={downloadableAccess.includes('VISITORS')} 
                                    hasError={validationErrors && validationErrors.accessType} 
                                />
                            </div>
                        </div>  
                    </>}

                    <div className='flex flex-row-reverse my-[10px]'>
                        <button onClick={()=>{setChangingFile(!changingFile)}} className='text-vcm-purple hover:text-gray-400 text-sm font-[550] transition duration-200 flex items-center justify-center gap-x-[5px]'>
                            {changingFile ? <CloseIcon className={`w-4 h-4`} /> : <ArrowPathIcon className={`w-4 h-4`} />}
                            {changingFile ? 'Cancel' : 'Change file'}
                        </button>
                    </div>

                    {documentTypeSelected && changingFile && <FileUpload
                        hasError={validationErrors.file}
                        fieldLabel={`File`}
                        returnFileDetails={(details)=>{
                            setFile(details)
                        }}
                        requiredField={true}
                        maxFileSize={200}
                        acceptedFormats={allowedFormats[newDownloadablePayload.documentType]}
                    />}

                    {!changingFile && <div className='w-full bg-gray-50 flex items-center justify-center h-[200px] border'
                        style={{
                            backgroundImage: downloadable.documentType === 'IMAGE' ? `url(${downloadable.documentUrl})` : '',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                        }} 
                    >
                        {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-8 h-8 text-gray-500`} />}
                        {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-8 h-8 text-gray-500`} />}
                        {downloadable.documentType === 'DOCUMENT' && <TextIcon className={`w-8 h-8 text-gray-500`} />}
                    </div>}
                </div>
            </div>              

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update downloadable`}
                    buttonAction={()=>{pushDownloadable()}}
                    processing={downloadablesSelector.updatingDownloadable}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{closeFunction()}}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default EditDownloadable